import React from "react";
import "./about.css";
import ME from "../../assets/me_about.jpg";

const About = () => {
  return (
    <section id="about">
      <h5>WHO IS DAHUD YUSUF?</h5>
      <h2>A Bit About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="About_Image" />
          </div>
        </div>

        <div className="about__content">
          <p>
            As a Full-Stack Developer with 3+ years of experience, I specialize in building enterprise-level web applications using modern technologies. I recently architected and developed <strong>FricaLearn</strong>, a comprehensive Learning Management System from scratch using Laravel and React.js, featuring payment integration, gamification, real-time chat, and AI-powered features.
            <br /> <br /> 
            My expertise spans the full development stack - from designing complex database architectures with <strong>Laravel (PHP)</strong> to creating responsive, dynamic frontends with <strong>React.js and TypeScript</strong>. I've successfully integrated payment systems (Stripe/Paystack), implemented AI features using OpenAI's GPT-4, and built real-time communication systems.
            <br /> <br />
            Beyond full-stack development, I bring deep <strong>WordPress expertise</strong>, having worked remotely for international agencies delivering high-performance, SEO-optimized websites with 90+ Google PageSpeed scores. Whether it's building a complex SaaS platform or crafting a performant WordPress site, I deliver production-ready solutions that exceed expectations.
          </p>

          <a href="https://wa.me/message/SOM4EYZEQ5T7L1" className="btn btn-primary">
            Let's Talk About Your Projects
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
